import {
    menu,
    subMenu,
    getMenu,getSubMenu
  } from '@/menuData'
import { Route } from 'vue-router'
export default {
    //存储数据
    state: {
        isCollapse: false,
        editableTabsValue: '/index',
        tagsList: [
            {"title":"首页","name":"/index"}
        ],
        activeIndex: 1,//一级目录中第一个id
        menuList: [],//一级目录
        subMenu: [],//二级目录
        subUrl: [],//二级目录地址
        secMenu:[],//接收所有二级
    },
    //调用方法
    mutations: {
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        //修改editableTabsValue
        changeEditTabs(state,value) {
            state.editableTabsValue = value
        },
        //修改tagsList
        changeTagsList(state,value) {
            state.tagsList = value
            sessionStorage.setItem("tagsList",JSON.stringify(state.tagsList))
        },
        //修改menuList
        changeMenuList(state,value) {
            state.menuList = value
        },
        //修改subMenu
        changeSubMenu(state,value) {
            state.subMenu = value
        },
        //修改secMenu
        changeSecMenu(state,value){
            state.secMenu = value
        },
        //修改subUrl
        changeSubUrl(state,value) {
            state.subUrl = value
        },
        //修改activeIndex
        changeActIndex(state,value) {
            state.activeIndex = value;
            sessionStorage.setItem("activeIndex",state.activeIndex)
        },
        //点击一级目录
        selectMenu(state, val) {
            state.subMenu = subMenu.filter(val => {
                return val.pid == parseInt(state.activeIndex)
            });
            if(state.subMenu[0]&&state.subMenu[0].children.length>0){
                state.subUrl = state.subMenu[0].children[0].url;
            }else{
                state.subUrl = state.subMenu[0].url;
            }
        },
        selectSub(state, val) {
            // console.log('vuex接收到的值',val)
            subMenu.forEach(item => {
                item = Object.assign({}, item)
                if (item.children.length>0) {
                    item.children.filter(child => {
                        if(child.url == val) {
                            state.activeIndex = item.pid
                        }
                    })
                } else {
                    if(item.url == val) {
                        state.activeIndex = item.pid
                    }
                }
            })
            this.commit('selectMenu')
        },
        //关闭标签
        closeTab(state, val) {
            let result = state.tagsList.findIndex(item => item.name === val.name)
            state.tagsList.splice(result, 1)
        },
    },
    actions: {}
}



// WEBPACK FOOTER //
// ./src/store/tab.js